export default {"src":"/_next/static/media/bank-blue.ee7d4566.svg","height":50,"width":50,"blurWidth":0,"blurHeight":0};